import React from 'react'
// Import CommonBanner Area
import CommonBanner2 from '../component/Common/CommonBanner2'
// import MakeDonationArea
import MakeDonationArea from '../component/MakeDonation'


const MakeDonationPage = () => {
  return (
    <>
      <CommonBanner2 heading="Make a donation" pagination="Make a donation"/>
      <MakeDonationArea/>
    </>
  )
}

export default MakeDonationPage